 import { Orders } from "./ordersCrm/Orders";
// import { Booking } from "./Booking/Booking";
import { Seller } from "./Seller/Seller";
// import { Customer } from "./Customer/Customer";
import { Product } from "./Product";
import { Reports } from "./Reports";
import { Zoom } from "./Zoom";
import { AdminTab } from "./Admin/index"
// import { PurchaseOrder } from "./PurchaseOrder";
// import { forms } from "./forms";
import { AdminReports } from './AdminReports'
import { Inventory } from "./Inventory"
// import { fulfilled } from "./Orders" 
import { FinancialReports } from "./FinancialReports";
import { Dashboard } from "./Dashboard/index";
import { vendor } from "./Vendor";
import { Role12Reports } from "./Role12Reports";
import { MainDashboard } from "./MainDashboard";
import { WhatsappLeadTab, SHOULD_SHOW_WHATSAPP_LEAD } from "./WhatsappLead";
import { LeadDistributionTab, SHOULD_SHOW_LEAD_DISTRIBUTION } from "./LeadDistribution";
import { UploadOrderTab, SHOULD_SHOW_UPLOAD_ORDER } from "./UploadOrder";
import { DigitalMarketingTab, SHOULD_SHOW_DIGITAL_MARKETING } from "./DigitalMarketing";
import { MissedCallLeadsTab, SHOULD_SHOW_MISSED_CALL_LEADS } from "./MissedCallLeads";
import { ControlTowerTab, SHOULD_SHOW_CONTROL_TOWER } from "./ControlTower";
import { VoiceTab, SHOULD_SHOW_VOICE } from "./Voice";
import { Ops } from "./ops";
import { CouponRelated } from "./Coupon";
import { MarketingTab } from "./Marketing Reports/index"
import { fcAdmin } from "./FcAdmin"
import { Packing } from "./PackingOrder";

import { Bulk } from "./Bulk";
import { BulkOrders } from "./AllBulkOrders";
import { getDecryptDataFromLocal } from "../utils/encrypt";
import { ONDC } from "./ONDC";
import {Aspire} from './Aspire'
import { DeliveryCenterOnlyMenu } from "./Bulk/DeliveryCenterOnlyMenu";
import { DELIVERY_CENTER_EXTERNAL_USERS } from "./Bulk/BulkAnalysis/deliveryCenterExternalAccess";


//-----------------------|| MENU ITEMS ||-----------------------//
var item = []
var role = getDecryptDataFromLocal('setRole')
let cohortTeam = localStorage.getItem('cohortTeam')
let phoneNumber = getDecryptDataFromLocal('phoneNumber')

console.log("seller role===>", role)


// var role = 12

// Shipshopy external users (see deliveryCenterExternalAccess.js) — short-circuits every
// role-based branch below so the sidebar shows only Delivery Center Orders, regardless of
// whatever role/userType these two accounts otherwise carry.
if (DELIVERY_CENTER_EXTERNAL_USERS.includes(phoneNumber)) {
  item = [DeliveryCenterOnlyMenu]
}

//admin
else if (role == 1) {
  item = [MainDashboard, Orders, Seller, Product, Reports, MarketingTab, Zoom, AdminTab, AdminReports, Dashboard, FinancialReports, Ops, Inventory, fcAdmin, vendor, CouponRelated,Bulk,BulkOrders]
  // item = [MainDashboard, Orders, Seller, Product, Reports, Zoom, AdminTab, AdminReports, Dashboard, FinancialReports, Ops, Inventory, vendor]
}


//ops
else if (role == 2) {
  if(['9319132363','9907125180','8826956978','9911579990','9990619120','9560087843'].includes(phoneNumber)){
    item = [Orders, Seller, Product, Reports, Inventory, MarketingTab, FinancialReports, Zoom, Dashboard, Ops, AdminTab, fcAdmin, vendor, CouponRelated,Bulk,BulkOrders]
  } else if(phoneNumber=='8448300516'){
    item = [Orders, Seller, Product, Reports, Inventory, MarketingTab, FinancialReports, Zoom, Dashboard, Ops, AdminTab, vendor, CouponRelated,Bulk,BulkOrders]
  }  
  else {
    item = [Orders, Seller, Product, Reports, Inventory, MarketingTab, FinancialReports, Zoom, Dashboard, Ops, AdminTab, vendor, CouponRelated,Bulk,BulkOrders,]
  }
}

//
else if (role == 3) {
  item = [Orders, Seller, Product, Reports, FinancialReports, Dashboard,Bulk,BulkOrders]
}
else if (role == 4) {
  if (['9034223172','9891774071'].includes(phoneNumber) ) {
    item = [Orders, Seller, Product, Reports, Inventory, Dashboard, CouponRelated, MarketingTab, fcAdmin,Bulk,BulkOrders]
  }
  else if (['8076096127','8178277221','9811068834'].includes(phoneNumber)) {
    item = [Orders, Seller, Product, Reports, AdminTab,Inventory, Dashboard, CouponRelated, fcAdmin, FinancialReports,Bulk,BulkOrders]
  }

  else if(phoneNumber=='9667530528') {
    item = [Orders, Seller, Product, Reports, Inventory, Dashboard, CouponRelated, fcAdmin,Bulk,BulkOrders,Ops,AdminTab]
  }
  else if(['8969708515'].includes(phoneNumber)){
    item = [Orders, Seller, Product, Reports, Inventory, Dashboard, CouponRelated, fcAdmin,AdminTab,FinancialReports,Bulk,BulkOrders]
  }
  else if(['9873804039','9899911403','8384080103','8851763878','9911960633'].includes(phoneNumber)){
    item = [Orders, Seller, Product, Reports, Inventory, Dashboard,Ops ,CouponRelated, fcAdmin,FinancialReports,Bulk,BulkOrders]
  }
  else if(['8882954273','7065923736'].includes(phoneNumber)){
    item = [Orders, Seller, Product, Reports, Inventory, Dashboard, CouponRelated, fcAdmin,AdminTab,Bulk,BulkOrders]
  }

  else {
    item = [Orders, Seller, Product, Reports, Inventory, Dashboard, CouponRelated, fcAdmin,Bulk,BulkOrders]
  }
}

//sales
else if (role == 5 && phoneNumber == '8383994129') {
  item = [Orders, Seller, Dashboard, Product, Bulk, BulkOrders, AdminTab]
}

else if (role == 5 && ['9359536247', '9119008412', '9027110892', '7007206979', '9315116177','7701974309'].includes(phoneNumber)) {
  item = [Seller, Dashboard, Product, Inventory,Bulk,BulkOrders]
}

else if (role == 5 && cohortTeam == 'true') {
  if (phoneNumber == "8368765621") {
    item = [Orders, Seller, Dashboard, Product, Inventory,Bulk,BulkOrders]
  } else {
    item = [Orders, Seller, Dashboard, Product,Bulk,BulkOrders]
  }
} else if (role == 5 && cohortTeam == 'false') {
  item = [Orders,Seller, Dashboard, Product,Bulk,BulkOrders]
}

else if (role == 6) {
  item = [Orders, Seller, Product, Reports]
}

//trainers

else if (role == 7) {
  item = [Orders, Seller, Product, Reports, Zoom, AdminTab]
}
else if (role == 8) {
  item = [vendor]
}
else if (role == 9) {
  item = [Orders, Seller, Product]
}
else if (role == 10) {
  item = [AdminTab]
}
else if (role == 12) {
  item = [Orders, Product, Zoom, AdminTab, Role12Reports, Dashboard]
}
else if (role == 13) {
  // Bulk group (Bulk Order + Bulk Analysis — Download Bulk Order/Product
  // Data, Delivery Center Orders) now shown to every team lead, not just
  // the two hardcoded phone numbers below — the backend already scopes all
  // three (getBulkReportAgentFilter / getDeliveryCenterOrders) to the TL's
  // own + tagged agents' data only. Shailendra 2026-08-05.
  if(['7701974309','8383908752'].includes(phoneNumber)){
    item = [Orders, Seller, Product, Reports, Zoom, Dashboard, AdminTab,Bulk,BulkOrders]
  }else{
    item = [Orders, Seller, Product, Reports, Zoom, Dashboard, AdminTab,Bulk,BulkOrders,Ops]
  }
}
else if (role == 14) {

  if (['9870251244', "8851245596", "9310848352", "9911579990", "7982526137", "9990619120", "9560382051",'8368535431','8750022180'].includes(phoneNumber)) {
    item = [Orders, Seller, Product, Reports, Zoom, Dashboard, Ops, Inventory,Bulk,BulkOrders,AdminTab]

  }
  else if(['9560382051'].includes(phoneNumber)){
    item = [Orders, Seller, Product, Reports, Zoom, Dashboard,AdminTab,Ops, Inventory,Bulk,BulkOrders]
  } else if(['7838932786'].includes(phoneNumber)){
    item = [Orders, Seller, Product, Reports, Zoom, Dashboard, AdminTab,fcAdmin, Ops, Inventory,Bulk,BulkOrders,FinancialReports]
  } 
  
  else {
    item = [Orders, Seller, Product, Reports, Zoom, Dashboard, AdminTab,Ops,Inventory,Bulk,BulkOrders]
  }
}
else if (role == 15) {
  item = [Dashboard]
}
else if (role == 16) {
  item = [Orders, Seller, Product, Reports, Zoom, AdminTab, Inventory, MarketingTab]
}
else if (role == 17) {
  item = [MainDashboard, Orders, Seller, Product, Reports, Dashboard, Ops, AdminTab, FinancialReports, Inventory,BulkOrders]
  if (['9268096291', '9891769967', '8076833686','9990619120'].includes(phoneNumber)) {
    item = [MainDashboard, Orders, Seller, Product, Reports, Dashboard, Ops, AdminTab, MarketingTab, FinancialReports, Inventory, Bulk, BulkOrders]
  }
   if(["7532035127",'8076096127','9911579990'].includes(phoneNumber)){
    item = [MainDashboard, Orders, Seller, Product, Reports, Dashboard, Ops, AdminTab, FinancialReports, Inventory, fcAdmin,Bulk,BulkOrders]
  }
}
else if (role == 18) {
  item = [Orders, Seller, Product, Reports, Zoom, Dashboard, AdminTab, Inventory]
}
else if (role == 19) {
  item = [Packing]
}

if(phoneNumber=='9719836187'||phoneNumber=='7065923736'||phoneNumber=='8920702782'){
  item.push(ONDC)
}
if(phoneNumber=='9719836187'){
  item.push(Aspire)
}
if(phoneNumber=='8130902064'){
  if(!item.includes(Bulk)){
      item.push(Bulk)
  }
  if(!item.includes(BulkOrders)){
      item.push(BulkOrders)
  }
}

// WhatsApp agents (admins.whatsappAgent === true) get the MainDashboard
// group prepended so the "My Chats" link inside it becomes reachable.
// MainDashboard internally gates the MyChats item on the same flag.
if (localStorage.getItem('whatsappAgent') === 'true' && !item.includes(MainDashboard)) {
  item.unshift(MainDashboard);
}

// Order WA inbox users always get MainDashboard so the
// "Order WA Inbox" link inside it is reachable regardless of their role.
if (localStorage.getItem('orderWaInbox') === 'true' && !item.includes(MainDashboard)) {
  item.unshift(MainDashboard);
}

// New top-level "Whatsapp Lead" group — shows for WA agents + supervisors
// (role 1, role 17, bulkWaManager). Placed near the top after the dashboard
// groups so it's easy to find.
if (SHOULD_SHOW_WHATSAPP_LEAD && !item.includes(WhatsappLeadTab)) {
  // Insert right after MainDashboard if present, else at the very top
  const idx = item.indexOf(MainDashboard);
  if (idx >= 0) item.splice(idx + 1, 0, WhatsappLeadTab);
  else item.unshift(WhatsappLeadTab);
}

// "Lead Distribution" top-level group — lead-flow reporting (TAT, latency),
// as opposed to Whatsapp Lead which is what an agent DID with the lead. Sits
// right after Whatsapp Lead. (2026-08-29, Ameen's reporting asks.)
if (SHOULD_SHOW_LEAD_DISTRIBUTION && !item.includes(LeadDistributionTab)) {
  const after = item.indexOf(WhatsappLeadTab);
  if (after >= 0) item.splice(after + 1, 0, LeadDistributionTab);
  else {
    const idx = item.indexOf(MainDashboard);
    if (idx >= 0) item.splice(idx + 1, 0, LeadDistributionTab);
    else item.unshift(LeadDistributionTab);
  }
}

// "Missed Call Leads" top-level group — lifted out of Whatsapp Lead. Sits
// right after Whatsapp Lead so the two lead inboxes are adjacent.
if (SHOULD_SHOW_MISSED_CALL_LEADS && !item.includes(MissedCallLeadsTab)) {
  const after = item.indexOf(WhatsappLeadTab);
  if (after >= 0) item.splice(after + 1, 0, MissedCallLeadsTab);
  else {
    const idx = item.indexOf(MainDashboard);
    if (idx >= 0) item.splice(idx + 1, 0, MissedCallLeadsTab);
    else item.unshift(MissedCallLeadsTab);
  }
}

// "Upload Order" top-level group — sheet upload + MIS approval workflow.
// Same placement strategy: right after MainDashboard / WhatsappLead.
if (SHOULD_SHOW_UPLOAD_ORDER && !item.includes(UploadOrderTab)) {
  const after = item.indexOf(WhatsappLeadTab);
  if (after >= 0) item.splice(after + 1, 0, UploadOrderTab);
  else {
    const idx = item.indexOf(MainDashboard);
    if (idx >= 0) item.splice(idx + 1, 0, UploadOrderTab);
    else item.unshift(UploadOrderTab);
  }
}

// DM-only scoping — users with `dashboardRoles` set on their admin doc
// (influencer_lead, marketing_manager, amazon_lead, etc.) are scoped to
// the Digital Marketing section only. Prevents e.g. content-team members
// (role 7 with 'influencer_lead') from seeing Orders/Products/Zoom, and
// prevents marketing_lead (role 9) from seeing Orders/Seller/Product.
// JWTContext writes `dmRoles` to localStorage on login (parsed from
// /api/ai/me). Any non-empty value → strip everything else.
//
// EXCEPT `founder` role — that means "see EVERYTHING" (Shailendra, Aftab,
// Shahnawaz-dev). Founders keep their full sidebar and ALSO get DM added.
// Shailendra 2026-07-02.
try {
  const dmRoles = JSON.parse(localStorage.getItem('dmRoles') || '[]');
  const isFounder = Array.isArray(dmRoles) && dmRoles.includes('founder');
  if (Array.isArray(dmRoles) && dmRoles.length > 0 && !isFounder) {
    item = [];
  }
} catch (e) { /* localStorage missing / bad JSON — treat as no roles */ }

// "Digital Marketing" top-level group — marketplace P&L / Ads / Inventory
// dashboards across Amazon, Flipkart, Zepto, Shopify. Phone-allow-list
// gated (Phase 1 = Shailendra only). Same placement strategy.
if (SHOULD_SHOW_DIGITAL_MARKETING && !item.includes(DigitalMarketingTab)) {
  const after = item.indexOf(UploadOrderTab);
  if (after >= 0) item.splice(after + 1, 0, DigitalMarketingTab);
  else {
    const after2 = item.indexOf(WhatsappLeadTab);
    if (after2 >= 0) item.splice(after2 + 1, 0, DigitalMarketingTab);
    else {
      const idx = item.indexOf(MainDashboard);
      if (idx >= 0) item.splice(idx + 1, 0, DigitalMarketingTab);
      else item.unshift(DigitalMarketingTab);
    }
  }
}

// "Control Tower" top-level group — owner-only exception dashboards. Sits right
// after Digital Marketing.
if (SHOULD_SHOW_CONTROL_TOWER && !item.includes(ControlTowerTab)) {
  const after = item.indexOf(DigitalMarketingTab);
  if (after >= 0) item.splice(after + 1, 0, ControlTowerTab);
  else {
    const idx = item.indexOf(MainDashboard);
    if (idx >= 0) item.splice(idx + 1, 0, ControlTowerTab);
    else item.unshift(ControlTowerTab);
  }
}

// "Voice" top-level group — Phonomenal click-to-call test tab, gated to an
// explicit phone-number allowlist (not role-based). Sits right after Control
// Tower. Shailendra 2026-08-19.
if (SHOULD_SHOW_VOICE && !item.includes(VoiceTab)) {
  const after = item.indexOf(ControlTowerTab);
  if (after >= 0) item.splice(after + 1, 0, VoiceTab);
  else {
    const idx = item.indexOf(MainDashboard);
    if (idx >= 0) item.splice(idx + 1, 0, VoiceTab);
    else item.unshift(VoiceTab);
  }
}

// Shipshopy external users — FINAL override, must run after every push/splice above (Upload
// Order, WhatsApp Lead, Digital Marketing, ONDC, Aspire, etc. all insert into `item` based on
// independent localStorage flags/phone lists that the early short-circuit near the top of this
// file can't preempt). Re-applying it here guarantees these two accounts only ever see one item
// regardless of what any of those flags happen to be set to.
if (DELIVERY_CENTER_EXTERNAL_USERS.includes(phoneNumber)) {
  item = [DeliveryCenterOnlyMenu];
}

const menuItems = {
  items: item
};
// bookiing
export default menuItems;
